import texts from '../../Localization/AISearch/texts';

export const wrapIntoHTML = (text: string = ''): string => {
    return `<p>${text}</p>`;
};

export const unwrapHtmlParagraph = (html: string = ''): string => {
    // Remove the outer <p> tags if they exist.
    return html.replace(/^<p[^>]*>(.*?)<\/p>$/s, '$1');
};

export const prepareOptions = (data: {[key: string]: string}, type: string) =>
    Object.keys(data).map(key => {
        return {
            label: texts[`ai_writing_${key}_label`],
            value: key,
            data: {type}
        };
    });
